import { useState } from 'react';
import { Link } from 'react-router-dom';
import useProductSearch from '../../context/ProductSearchContext';
import UserDrawer from './UserDrawer';

export default function HomeHeader() {
  const { openSearch } = useProductSearch();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <header className="home-header">
        <button
          type="button"
          className="home-search"
          onClick={openSearch}
        >
          <span className="home-search__placeholder">搜索</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
            <path d="M20 20l-3-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>

        <Link to="/messages" className="home-header__icon-btn" aria-label="訊息公告">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>

        <button
          type="button"
          className="home-header__icon-btn"
          aria-label="用戶資訊"
          onClick={() => setDrawerOpen(true)}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M5 7h14M5 12h14M5 17h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      </header>

      <UserDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
